import React from "react";

import { articles } from "../../Data";

import Card from "../card/Card";

import { Wrapper, Content } from "./BlogsList.styles";

const BlogsList = () => {
  return (
    <Wrapper>
      <Content>
        <h1>My Articles</h1>

        {articles.map((article, index) => {
          return (
            <Card
              key={index}
              // title={project.title}
              // description={project.title}
              // stack={project.stack}
              // buttons={[["Case Study"], ["Code"], ["Blob"]]}

              object={article}
            />
          );
        })}
      </Content>
    </Wrapper>
  );
};

export default BlogsList;
